import React from 'react';
import { Error400 } from '../../asset';
import PrimaryButton from '../../component/button/PrimaryButton';
import { t } from 'i18next';

const ErrorPage400 = () => {
  return (
    <div className='flex flex-col justify-center items-center'>
      <img src={Error400} alt='img-error-400' />
      <p className='font-sans font-bold text-4xl mt-[24px]'> Error Bad Request </p>
      <p className='font-sans font-bold text-2xl mt-[4px]'> Your request resulted in an error </p>
      <PrimaryButton 
          styles='mt-[24px]'
          // action={() => setStartOpen(true)} 
          text={t("Back To Home")} 
        />
    </div>
  );
}

export default ErrorPage400;